import type { StatusFinanceiro } from "./obras.types";

export const INSPECAO_CASCO_VALUES = ["DRY_DOCKING", "UNDERWATER"] as const;
export type TipoInspecaoCasco = (typeof INSPECAO_CASCO_VALUES)[number];

export interface CriarObraTipoPayload {
  tipoObraId: string;
  dominante: boolean;
  cliente: string | null;
  contrato: string | null;
  inspecaoCasco: TipoInspecaoCasco | null;
  /** Escopo Macro (HU 2479, em análise): o wizard ainda não coleta; segue vazio. */
  escoposMacro: never[];
}

export interface CriarObraCentroCustoPayload {
  centroCustoId: string;
  principal: boolean;
  tipos: CriarObraTipoPayload[];
}

/** Corpo de `POST /api/obras` (contrato do hub-core, HU 2543). */
export interface CriarObraPayload {
  embarcacaoId: string;
  localPlanejadoId: string | null;
  manutencaoCorretiva: boolean;
  statusObraId: string;
  statusFinanceiro: StatusFinanceiro;
  observacoes: string | null;
  descricao: string;
  /** `AAAA-MM-DD`. */
  inicio: string;
  periodos: { periodoObraId: string; duracao: number; meta: number | null }[];
  centrosCusto: CriarObraCentroCustoPayload[];
  /** Só com troca manual do dominante. */
  justificativaDominante: string | null;
  justificativaCondicoes: string | null;
  equipe: { papelObraId: string; usuarioId: string; inicio: string; fim: string }[];
  /** Justificativa dos diálogos de conflito/indisponibilidade da Etapa 4 (HU 2530 RN08). */
  justificativaEquipe: string | null;
}
